import Dropdown from '~/js/utils/dropdown';

export default ((node) => {
  const { group } = node.dataset;
  const key = group;
  const list = node.querySelector('.dropdown');
  const Group = Dropdown(list, key, false, true);
  const triggers = [...node.querySelectorAll('[data-group-trigger]')];
  const actions = [...node.querySelectorAll('[data-action]')];

  const pos = () => {
    const siteContainer = document.querySelector('[data-site-container]');
    const rect = list.getBoundingClientRect();
    const screen = siteContainer ? siteContainer.getBoundingClientRect().width : window.innerWidth;

    if (screen < rect.x + rect.width) {
      list.classList.add('!left-auto', 'right-0');
    }
  };

  if (triggers.length) {
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        Group.toggle();
        pos();
      });
    });
  }

  pos();

  if (actions && actions.length) {
    actions.forEach((x) => {
      const { action } = x.dataset;

      switch (action) {
        case 'close':
          x.addEventListener('click', () => Group.close());
          break;

        default:
          break;
      }
    });
  }
});
